(function($) {
    $.fn.sideArchive = function() {
        let $holder = $('.js-calendar-range-holder');
        const $calendarHolder = $holder.find('.js-calendar-range-field');
        const $calendars = $holder.find('.js-calendar');
        let $calendarSideBlock = $('.js-side-calendar-wrap');
        let $calendarTitleBlock = $('.js-title-calendar-wrap');

        let $tagList = $('.js-tag-list');
        let $tagListSideBlock = $('.js-side-tag-wrap');
        let $tagListTitleBlock = $('.js-title-tag-wrap');

        let resizeTimeout;

        /**
         * Перемещение блоков в зависимости от разрешения
         */
        const placeBlocks = function () {
            if (SVK.checkBreakpoint() === 'desktop') {
                // блоки отображаются в сайдбаре
                $holder.appendTo($calendarSideBlock);
                $tagList.appendTo($tagListSideBlock);
            } else {
                // блоки отображаются в заголовке
                $holder.appendTo($calendarTitleBlock);
                $tagList.appendTo($tagListTitleBlock);
            }
        };

        /**
         * Инициализация
         */
        const init = function () {
            placeBlocks();

            // Ресайз окна
            $(window).on('resize', function() {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(function() {
                    placeBlocks();
                }, 100);
            });

            // Обработка кликов
            $(document).on('click', function (e) {
                const $target = $(e.target);
                const $currentCalendar = $target.closest('.js-calendar-range-field');
                let isInsideCalendarWrap = !!$target.closest('.js-calendar-range-field').length;
                const isTitleBlock = !!$target.closest($calendarTitleBlock).length;
                const isIconCalendar = !!$target.closest('.js-icon-calendar').length;


                if (isIconCalendar) {
                    $calendarHolder.filter(function (index, el) {
                        return el !== $currentCalendar.get(0);
                    }).removeClass('opened');
                    $currentCalendar.toggleClass('opened');

                    return;
                }

                if (!isInsideCalendarWrap && !isTitleBlock) {
                    // Клик вне всех блоков календаря
                    $calendarTitleBlock.removeClass('active');
                    $calendarHolder.removeClass('opened');
                } else if (isTitleBlock && !isInsideCalendarWrap) {
                    // Клик по переключателю
                    $calendarTitleBlock.toggleClass('active');
                    $calendarHolder.removeClass('opened');
                }

                if (SVK.checkBreakpoint() === 'mobile') {
                    if ($target.is($holder)) {
                        $calendarHolder.removeClass('opened');
                        $calendarTitleBlock.removeClass('active');
                    }
                }
            });
        };

        init();

        return this;
    };
})(jQuery);
